<style lang="css" scoped>
.languages div{
  min-width: 50px;
  margin: 3px 5px;
  display: flex;
}
.languages div span{
  height: 20px;
  width: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 3px;
}
.languages div span img{
  max-height: 20px;
  max-width: 20px;
}
.languages .changeable:hover{
  color: #008acc;
  cursor: pointer;
}
hr {
  margin: 0 5px;
}
</style>

<template>

    <v-layout row wrap class="languages text-xs-center my-3" justify-center>

      <div :class="lang !== 'en' ? 'changeable' : ''" @click="changeLang('en')">
        <span>
          <img src="/images/flags/us.png" alt="US Flag">
        </span>
        English
      </div>
      <hr>
      <div :class="lang !== 'he' ? 'changeable' : ''" @click="changeLang('he')">
        <span>
          <img src="/images/flags/il.png" alt="Israel Flag">
        </span>
        עברית
      </div>

    </v-layout>

</template>

<script>
export default {
    name: 'Languages',
    data() {
        return {
          lang: null,
        }
    },
    methods: {
      changeLang(lang){
        if (this.lang != lang) {
          Lang.set(lang);
          window.location.reload();
        }
      }
    },
    created() {
      this.lang = Lang.get();
    },
    mounted() {

    },
}
</script>
